import { db } from "./firebase";
import { doc, collection, setDoc, addDoc, increment, Timestamp, query, limit, where, getDocs } from "firebase/firestore";

export const levels = {
    1: "A1",
    2: "A2",
    3: "B1",
    4: "B2",
    5: "C1",
    6: "C2"
};

const progression = [0, 49200, 65600, 82000, 98400, 131200];

export function getCumulative(level) {
    if (level === 1) return progression[0];
    let cumulative = 0;
    for (let i = 0; i < level; i++) {
        cumulative += progression[i];
    }
    return cumulative;
}

export function getLevel(proficiency) {
    if (proficiency <= getCumulative(2)) return 1;
    if (proficiency <= getCumulative(3)) return 2;
    if (proficiency <= getCumulative(4)) return 3;
    if (proficiency <= getCumulative(5)) return 4;
    if (proficiency <= getCumulative(6)) return 5;
    return 6;
}

export function shuffle(arr) {
    let copy = [...arr];
    let j, temp;
    for (let i = copy.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        temp = copy[i];
        copy[i] = copy[j];
        copy[j] = temp;
    }
    return copy;
}

function calculateMultiplier(then, now) {
    let milisecondDiff = now - then;
    let dayDiff = Math.floor(milisecondDiff / (1000 * 60 * 60 * 24));
    if (dayDiff < 1) return 0;
    if (dayDiff < 3) return .125;
    if (dayDiff < 7) return .25;
    if (dayDiff < 10) return .5;
    if (dayDiff < 14) return .75;
    return 1;
}

export async function getProgressionMultiplier(currentUser, id) {
    try {
        const q = query(collection(db, "userInfo", currentUser.uid, "history"), where("id", "==", id), limit(1));
        const snapshot = await getDocs(q);
        let multiplier = 0;
        if (!snapshot.empty) {
            const data = snapshot.docs[0].data();
            multiplier = calculateMultiplier(data.dateTaken.toDate(), new Date());
        } else {
            multiplier = 1;
        }
        return multiplier;
    } catch (error) {
        console.log(error);
    }
}

export async function writeQuizResult(currentUser, score, maxScore, bonus, exerciseLevel, title, id) {
    try {
        await setDoc(doc(db, "userInfo", currentUser.uid), {
            progressionPoint: increment(bonus)
        }, {merge: true});
        const data = {
            id: id,
            score: score,
            maxScore: maxScore,
            progressionEarned: bonus,
            level: exerciseLevel,
            dateTaken: Timestamp.fromDate(new Date()),
            exerciseTitle: title
        }
        await addDoc(collection(db, "userInfo", currentUser.uid, "history"), data);
        currentUser.progressionPoint += bonus;
        currentUser.actualCEFR = getLevel(currentUser.progressionPoint);
    } catch (error) {
        console.log(error);
    }
}